import type { FIXED_INDENTS, INDENTS } from 'vars/index'
import type { LAYOUT } from 'vars/layout-settings'
import type {
  Colors,
  TextBoxTypes,
  TextDecoration,
  WordBreak,
} from './TextBox.h'

import { styled } from '@linaria/react'
import { TextAligning, TextTransform } from './TextBox.h'

export const TextBoxSC = styled.span<{
  font?: TextBoxTypes
  maxLines?: number
  colorDefault?: Colors
  textTransform?: TextTransform
  width?: string
  alignment?: TextAligning
  horizontalPaddings?: LAYOUT | FIXED_INDENTS | INDENTS
  verticalPaddings?: LAYOUT | FIXED_INDENTS | INDENTS
  verticalGap?: FIXED_INDENTS
  textDecoration?: TextDecoration
  preWrap?: boolean
  wordBreak?: WordBreak
}>`
  color: ${({ colorDefault }) =>
    colorDefault ? `var(${colorDefault})` : `inherit`};
  font: ${({ font }) => `var(${font})`};
  overflow: ${({ maxLines }) => (maxLines ? 'hidden' : 'initial')};
  text-align: ${({ alignment }) => alignment || TextAligning.Left};
  text-transform: ${({ textTransform }) => textTransform || TextTransform.None};
  width: ${({ width }) => (Number(width) ? `${width}%` : 'auto')};
  max-width: 100%;
  padding-top: ${({ verticalPaddings }) =>
    verticalPaddings ? `var(${verticalPaddings})` : 0};
  padding-right: ${({ horizontalPaddings }) =>
    horizontalPaddings ? `var(${horizontalPaddings})` : 0};
  padding-bottom: ${({ verticalPaddings }) =>
    verticalPaddings ? `var(${verticalPaddings})` : 0};
  padding-left: ${({ horizontalPaddings }) =>
    horizontalPaddings ? `var(${horizontalPaddings})` : 0};
  display: ${({ maxLines }) => (maxLines! > 1 ? '-webkit-box' : 'initial')};
  white-space: ${({ maxLines, preWrap }) =>
    preWrap ? 'pre-wrap' : maxLines! === 1 ? 'nowrap' : 'normal'};
  -webkit-line-clamp: ${({ maxLines }) => maxLines || 'initial'};
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  word-break: ${({ wordBreak }) => wordBreak || 'break-word'};
  > *:not(:last-child) {
    margin-right: ${({ verticalGap }) =>
      verticalGap ? `var(${verticalGap})` : 'unset'};
  }

  text-decoration: ${({ textDecoration }) => textDecoration || 'initial'};
`
